import { defineStore } from "pinia";
import { useAdditionalServiceField } from "@/features/experience-curation/lib/useAdditionalServiceField";
import { useHasFunctionalFieldChange } from "@/features/experience-curation/queries/useHasRawFieldChange";
import { useCurationProductBrand } from "../product-brand/useCurationProductBrand";

export const useCurationNatGeo = defineStore("curation-setting-nat-geo-field", () => {
  const productBrandStore = useCurationProductBrand();
  const field = useAdditionalServiceField({
    id: "nat_geo_tour_level",
    functionalGroupCode: "NAT_GEO_TOUR_LEVELS",
  });
  const hasUnpublishedChange = useHasFunctionalFieldChange("nat_geo_tour_level");

  const isNatGeoBrand = computed(() => productBrandStore.model === "BRAND_NATIONAL_GEOGRAPHIC");
  const isVisible = computed(() => isNatGeoBrand.value && field.isVisible.value);

  // Clear nat-geo value when product brand changes away from NatGeo
  watch(isNatGeoBrand, (value) => {
    if (!value) field.model.value = "";
  });

  return { ...field, isVisible, hasUnpublishedChange };
});
